import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { House, People, LogoutCurve, Box1, Lifebuoy } from 'iconsax-react';

import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "./AuthContext";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div style={{ display: 'flex', backgroundColor: '#F7F8F3' }}>
      <Drawer
          className="drawer"
          variant="permanent"
          classes={{
              paper: 'drawer-paper',
          }}
          anchor="left"
      >
        <div className="logo">
          <div className="logo-primary">Legentibus</div>
          <div className="logo-secondary">for educators</div>
        </div>
        <List>
          <ListItem button selected={location.pathname.split('/')[1] === "account"} onClick={() => navigate('/account')}>
              <ListItemIcon>
                  <Box1 />
              </ListItemIcon>
              <ListItemText primary="Account" />
          </ListItem>
          <ListItem button selected={location.pathname.split('/')[1] === "classes"} onClick={() => navigate('/classes')}>
              <ListItemIcon>
                  <House />
              </ListItemIcon>
              <ListItemText primary="Classes" />
          </ListItem>
          <ListItem button selected={location.pathname.split('/')[1] === "students"} onClick={() => navigate('/students')}>
              <ListItemIcon>
                  <People />
              </ListItemIcon>
              <ListItemText primary="Students" />
          </ListItem>
          <ListItem button onClick={async () => {
            await logout();
            navigate('/login');
          }}>
            <ListItemIcon>
              <LogoutCurve />
            </ListItemIcon>
            <ListItemText primary="Log out" />
          </ListItem>
          <ListItem button component="a" href="https://help.legentibus.app/category/79-legentibus-for-educators" target="_blank">
              <ListItemIcon>
                  <Lifebuoy />
              </ListItemIcon>
              <ListItemText primary="Help" />
          </ListItem>
        </List>
      </Drawer>
      <div className="content">{children}</div>
    </div>
  );
};

export default Layout;
